module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-layout"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('h6', [_vm._v("藥物資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.code),
      expression: "medicineData.code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "code", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("料位號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.CGMH_number),
      expression: "medicineData.CGMH_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.CGMH_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "CGMH_number", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("學名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.generic_name),
      expression: "medicineData.generic_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.generic_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "generic_name", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("產品名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.product_name),
      expression: "medicineData.product_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.product_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "product_name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-2"
  }, [_c('h6', [_vm._v("藥盒資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥盒條碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.package_code2),
      expression: "medicineData.package_code2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.package_code2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "package_code2", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥瓶（身）條碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.package_code),
      expression: "medicineData.package_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.package_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "package_code", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("盒裝數量")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.pack_content),
      expression: "medicineData.pack_content"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "title": "調整盒裝數會影響藥盒內藥物數量，請務必重新盤點"
    },
    domProps: {
      "value": (_vm.medicineData.pack_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "pack_content", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "col-2"
  }, [_c('h6', [_vm._v("其他資訊")]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("管制等級")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.restrained_class),
      expression: "medicineData.restrained_class"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.restrained_class)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "restrained_class", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("衛生署字號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.license_id),
      expression: "medicineData.license_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.license_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "license_id", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("製造廠商")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.manufacturer),
      expression: "medicineData.manufacturer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.medicineData.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.medicineData, "manufacturer", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.return_when_empty),
      expression: "medicineData.return_when_empty"
    }],
    attrs: {
      "id": "switch-return-when-empty",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.medicineData.return_when_empty) ? _vm._i(_vm.medicineData.return_when_empty, null) > -1 : (_vm.medicineData.return_when_empty)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.medicineData.return_when_empty,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.medicineData, "return_when_empty", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.medicineData, "return_when_empty", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.medicineData, "return_when_empty", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.medicineData.return_when_empty
    },
    attrs: {
      "for": "switch-return-when-empty"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("需退空瓶")])]), _c('div', {
    staticClass: "switch-wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicineData.rx_check),
      expression: "medicineData.rx_check"
    }],
    attrs: {
      "id": "switch-rx-check",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.medicineData.rx_check) ? _vm._i(_vm.medicineData.rx_check, null) > -1 : (_vm.medicineData.rx_check)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.medicineData.rx_check,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.medicineData, "rx_check", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.medicineData, "rx_check", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.medicineData, "rx_check", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "slider",
    class: {
      'slider-on': _vm.medicineData.rx_check
    },
    attrs: {
      "for": "switch-rx-check"
    }
  })]), _c('span', {
    staticClass: "switch-title"
  }, [_vm._v("需覆核")])])]), _c('div', {
    staticClass: "col-5"
  }, [_c('h6', [_vm._v("藥物圖片")]), _c('hr'), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_picture_1) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_picture_1
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物照片(ㄧ)")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo1")
    },
    on: {
      "change": _vm.onChange
    }
  })])]), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_picture_2) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_picture_2
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥物照片(二)")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo2")
    },
    on: {
      "change": _vm.onChange
    }
  })])]), _c('div', {
    staticClass: "drug-image-setting"
  }, [_c('div', {
    staticClass: "drug-image-wrapper"
  }, [(_vm.medicineData.drug_box_picture) ? _c('img', {
    staticClass: "drug-image",
    attrs: {
      "src": _vm.medicineData.drug_box_picture
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("藥盒照片")]), _c('input', {
    staticClass: "form-control-file",
    attrs: {
      "type": "file",
      "id": (_vm.rowIndex + "-photo3")
    },
    on: {
      "change": _vm.onChange
    }
  })])])])]), _c('button', {
    staticClass: "btn btn-primary mr-2",
    on: {
      "click": _vm.updateMedicine
    }
  }, [_vm._v("儲存")]), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.deleteMedicine
    }
  }, [_vm._v("刪除")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e901cfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/DrugSettingsDetail.vue
// module id = 1471
// module chunks = 1